export const SHOW_LOADING = 'SHOW_CHANGE_PASSWORD_LOADING'
export const HIDE_LOADING = 'HIDE_CHANGE_PASSWORD_LOADING'
export const OPEN_DIALOG = 'OPEN_CHANGE_PASSWORD_DIALOG'
export const CLOSE_DIALOG = 'CLOSE_CHANGE_PASSWORD_DIALOG'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const CHECK_PASSWORD_STRENGTH_SUCCESS = 'CHECK_PASSWORD_STRENGTH_SUCCESS'
export const CHECK_PASSWORD_STRENGTH_FAILURE = 'CHECK_PASSWORD_STRENGTH_FAILURE'
